import m from 'moment'

// eslint-disable-next-line unicorn/no-unsafe-regex
export const currency = (val: number) => val.toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
export const currencyShort = (val: number) => {
  // eslint-disable-next-line unicorn/no-unsafe-regex
  if (val >= 10 ** 6) return (`${val / (10 ** 6)} M`).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  // eslint-disable-next-line unicorn/no-unsafe-regex
  if (val >= 10 ** 3) return (`${val / (10 ** 3)} K`).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return currency(val)
}

export const noCaps = (str: string) => str.split(' ').map(([first = '', ...rest]) => first.toUpperCase() + rest.map(w => w.toLowerCase()).join('')).join(' ')
export const date1 = (d: string) => m(d).format('MMMM YYYY')
export const date2 = (d: string) => m(d).format('LL')
export const calendar = (d: string) => m(d).calendar(null, {
  sameDay: '[oggi]',
  nextDay: '[domani]',
  // nextWeek: 'dddd prossimo',
  lastDay: '[ieri]',
// lastWeek: '[lo scorso] dddd',
// sameElse: 'DD/MM/YYYY'
})
